export const isInputValid = (rowData, allRowData, newAddition = false) => {

  const catID = rowData['detailed_category_id'];
  const catName = rowData['detailed_category_name'];

  const isNumber = (n) => { return /^-?[\d.]+(?:e-?\d+)?$/.test(n); };

  const isUniqueID = (rowData, allRowData) => {
    let rowIdNew = rowData.row_id;
    let rowIdOld;

    for (let i = 0; i < allRowData.length; i++) {
      if (allRowData[i].detailed_category_id == rowData.detailed_category_id) {
        rowIdOld = allRowData[i].row_id;
      };
    };

    if (!rowIdOld) rowIdOld = rowIdNew;
    return rowIdNew !== rowIdOld;
  };

  const isUniqueName = (rowData, allRowData) => {
    let rowIdNew = rowData.row_id;
    let rowIdOld;

    for (let i = 0; i < allRowData.length; i++) {
      if (allRowData[i].detailed_category_name == rowData.detailed_category_name) {
        rowIdOld = allRowData[i].row_id;
      };
    };

    if (!rowIdOld) rowIdOld = rowIdNew;
    return rowIdNew !== rowIdOld;
  };

  if (!isNumber(catID)) {
    return { status: false, errorMsg: 'Opps..! Detail category ID must be a number.' }
  } else if (newAddition && allRowData.some(elm => elm.detailed_category_id == rowData.detailed_category_id)) {
    return { status: false, errorMsg: 'Category already exists with provided Detailed Category ID.' }
  } else if (newAddition && allRowData.some(elm => elm.detailed_category_name == rowData.detailed_category_name)) {
    return { status: false, errorMsg: 'Category already exists with provided Detailed Category Name.' }
  } else if (!newAddition && isUniqueID(rowData, allRowData)) {
    return { status: false, errorMsg: 'Category already exists with provided Detailed Category ID.' }
  } else if (!newAddition && isUniqueName(rowData, allRowData)) {
    return { status: false, errorMsg: 'Category already exists with provided Detailed Category Name.' }
  } else if (!(catName)) {
    return { status: false, errorMsg: 'Opps..! You must provide category name.' }
  } else if (!catName.replace(/\s/g, '').length) {
    return { status: false, errorMsg: 'Opps..! Got only spaces in category name.' }
  } else {
    return { status: true }
  };

};